import { Form, Input, Button, InputNumber, message, Space } from 'antd';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { createCoupon } from '../../store/slices/couponSlice';

const AddCoupon = () => {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");

    const onSubmit = async (values) => {
        setLoading(true);
        setAlertMessage("");

        try {
            const result = await dispatch(createCoupon(values));

            if (createCoupon.fulfilled.match(result)) {
                navigate('/coupon');
            } else {
                setAlertMessage(result?.payload?.error || 'Error');
            }
        } catch (err) {
            setAlertMessage('Error creating coupon');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Form form={form} onFinish={onSubmit} layout="vertical">
            <Form.Item name="code" label="Coupon Code" rules={[{ required: true }]}>
                <Input />
            </Form.Item>

            <Form.Item name="discount_percent" label="Discount %" rules={[{ required: true }]}>
                <InputNumber min={1} max={100} style={{ width: '100%' }} />
            </Form.Item>

            {/* <Button type="primary" htmlType="submit">Submit</Button> */}
            <Form.Item>
                <Space>
                    <Button
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                    size="large"
                    block
                    style={{
                        height: '48px',
                        fontSize: '16px',
                        fontWeight: 600,
                        borderRadius: '8px',
                    }}
                    >
                        Save Changes
                    </Button>
                    <Button onClick={(e) => navigate(-1)}>Back</Button>
                </Space>
            </Form.Item>
        </Form>
    );
};

export default AddCoupon;